import "./AddSiteEquipment.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddSiteEquipmentComponentController from "./AddSiteEquipmentComponentController";

export default class AddSiteEquipmentComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddSiteEquipmentComponentController;
        this.templateUrl = "/App/Components/Site/DesignAndPlanning/AddSiteEquipment/AddSiteEquipment.html";
    }
}

module("mmManagePortal").component("mmAddSiteEquipment", new AddSiteEquipmentComponent());
